import { ArrowPathIcon } from '@heroicons/react/20/solid';
import type { UploaderConnection } from '../data/uploader-connection';

type CompanionCardProps = {
  connection: UploaderConnection;
  isActive?: boolean;
  busy?: boolean;
  onClick?: () => void;
};

export function CompanionCard({ connection, isActive, busy, onClick }: CompanionCardProps) {
  const isServer = connection.uploader?.is_server ?? false;

  const classes = [
    'flex items-center gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3',
    onClick
      ? 'hover:border-primary-400 transition cursor-pointer'
      : busy
        ? 'opacity-60 cursor-not-allowed'
        : '',
  ]
    .filter(Boolean)
    .join(' ');

  const content = (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-3">
        {isActive ? (
          <ArrowPathIcon className="h-2.5 w-2.5 text-blue-500 animate-spin" aria-hidden="true" />
        ) : (
          <span className="relative flex h-2.5 w-2.5">
            <span
              className={`absolute inline-flex h-full w-full animate-ping rounded-full opacity-75 ${busy ? 'bg-amber-400' : 'bg-green-400'}`}
            />
            <span
              className={`relative inline-flex h-2.5 w-2.5 rounded-full ${busy ? 'bg-amber-500' : 'bg-green-500'}`}
            />
          </span>
        )}
        <span className="text-sm font-medium text-gray-900">
          {connection.hostname || 'Unknown host'}
        </span>
        <span
          className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${
            isServer ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'
          }`}
        >
          {isServer ? 'Server' : 'Client'}
        </span>
      </div>
      {busy && <span className="text-xs text-amber-700">Busy — receiving in progress</span>}
    </div>
  );

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={classes}>
        {content}
      </button>
    );
  }

  return <div className={classes}>{content}</div>;
}
